import React, { useState } from "react";
import styles from "../../styles/admin.module.css";
import AdminHeader from "../../components/header";
import AdminSidebar from "../../components/sidebar";
import TableView from "../../components/table_view";
import {
  faPenToSquare,
  faTrash,
  faSpinner,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axiosInstance from "../../../AxiosInstance";
import DeleteModal from "../../components/delete_modal/delete_modal";
import { useNavigate } from "react-router-dom";
import { queryClient } from "../../../App";
import {
  toast,
  ToastTypes,
} from "../../../components/ajonjolib/toasts/toast/toast";

export default function AdminAccountsList() {
  const [rows, setRows] = useState([]);
  const [showDelete, setShowDelete] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [typeBillerLoading, setTypeBillerLoading] = useState({});
  const navigate = useNavigate();

  const roleToName = (role) => {
    switch (role) {
      case 1:
        return "Admin";
      case 2:
        return "Warehouse";
      case 3:
        return "Biller";
      case 4:
        return "Manager";
    }
  };

  const deleteObj = (id) => {
    axiosInstance.delete("admin_accounts/" + id + "/").then((response) => {
      window.location.reload();
    });
  };

  const editObj = (data) => {
    navigate("/admin/admins/create", { state: data });
  };

  const handleToggleTypeBiller = async (id, currentType, name) => {
    setTypeBillerLoading((prev) => ({ ...prev, [name]: true }));
    try {
      const response = await axiosInstance.patch(
        `admin_accounts/${id}/update-type-biller/`,
        {
          type_biller: currentType === "MANAGER" ? "GERANT" : "MANAGER",
        }
      );

      if (response.status === 200) {
        toast(`Type de biller mis à jour avec succès`, ToastTypes.SUCCESS);
        queryClient.invalidateQueries({
          queryKey: ["tableData-admin-user-list"],
        });
      }
    } catch (error) {
      console.error("Error updating type biller:", error);
      toast(
        "Erreur lors de la mise à jour du type de biller",
        ToastTypes.ERROR
      );
    } finally {
      setTypeBillerLoading((prev) => ({ ...prev, [name]: false }));
    }
  };

  const cols = [
    {
      title: "Name",
      internal: "user_data.name",
      filter: true,
      filterInternal: "name",
    },
    {
      title: "Last Name",
      internal: "user_data.lastname",
      filter: true,
      filterInternal: "lastname",
    },
    {
      title: "Phone Number",
      internal: "user_data.phone_number",
      filter: true,
      filterInternal: "phone_number",
    },
    {
      title: "Email",
      internal: "email",
      filter: true,
      filterInternal: "email",
    },
    {
      title: "Role",
      internal: "user_data.role",
      code: (row, data) => roleToName(data),
    },
    {
      title: "Warehouse",
      internal: "user_data.warehouse_name",
      filter: true,
      filterInternal: "warehouse",
    },
    {
      title: "Biller",
      internal: "user_data.supplier_name",
      filter: true,
      filterInternal: "supplier",
    },
    {
      title: "Manager",
      internal: "user_data.type_biller",
      code: (row, data) => {
        if (row.user_data?.role !== 3) return "-";
        return (
          <div className="d-flex align-items-center">
            <div className="form-check form-switch">
              <input
                className="form-check-input"
                type="checkbox"
                role="switch"
                id={`typeBillerSwitch${row.id}`}
                checked={data === "MANAGER"}
                onChange={() =>
                  handleToggleTypeBiller(row.id, data, row.user_data.name)
                }
                disabled={typeBillerLoading[row.user_data.name]}
              />
              {typeBillerLoading[row.user_data.name] && (
                <FontAwesomeIcon
                  icon={faSpinner}
                  spin
                  color="#9EA3AC"
                  className="ms-2"
                />
              )}
            </div>
          </div>
        );
      },
      filter: true,
      filterInternal: "type_biller",
    },
    { title: "Password", internal: "user_data.password" },
    {
      title: "Actions",
      internal: "id",
      code: (row, data) => {
        return (
          <div className={"d-flex justify-content-end"}>
            <div
              className={"pe-2"}
              style={{ cursor: "pointer" }}
              onClick={() => editObj(row)}
            >
              <FontAwesomeIcon icon={faPenToSquare} />
            </div>
            <div
              style={{ cursor: "pointer" }}
              onClick={() => {
                setSelectedId(row.id);
                setShowDelete(true);
              }}
            >
              <FontAwesomeIcon icon={faTrash} color={"#F00"} />
            </div>
          </div>
        );
      },
    },
  ];

  return (
    <div className={styles.mainContainer}>
      <AdminHeader />
      <AdminSidebar />

      <DeleteModal
        show={showDelete}
        setter={setShowDelete}
        onClick={() => deleteObj(selectedId)}
      />

      <div className={`${styles.container} me-4`}>
        <TableView
          fetchUrl={"admin_accounts"}
          pull={setRows}
          noPagination={true}
          title={"admins"}
          cols={cols}
          rows={rows}
          useReactQuery={"admin-user-list"}
        />
      </div>
    </div>
  );
}
